import type { AuthState, GetterClass } from '../../../models'
import type { AuthTokenService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

export class IsLoggedInGetter implements GetterClass {
  static execute(this: void, state: AuthState): boolean {
    const authTokenService: AuthTokenService = CONTAINER.get<AuthTokenService>(
      TYPES.AuthTokenService,
    )
    return !!state.token && !authTokenService.isExpired(state.token)
  }
}
